import { createFileRoute } from '@tanstack/react-router';

import { NotFoundMessage } from 'component/view/Redirects/NotFoundMessage';

// Catch-all route for unmatched /n/* paths
export const Route = createFileRoute('/n/$')({
  component: NotFoundMessage,
});
